import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPhoneNumber(phone: string): string {
  // Remove all non-digits
  const cleaned = phone.replace(/\D/g, "");

  // Format as +XXX XX XXX XX XX
  if (cleaned.length >= 10) {
    const country = cleaned.slice(0, cleaned.length - 9);
    const rest = cleaned.slice(-9);
    return `+${country} ${rest.slice(0, 2)} ${rest.slice(2, 5)} ${rest.slice(5, 7)} ${rest.slice(7)}`;
  }

  return phone;
}

export function maskEmail(email: string): string {
  const [localPart, domain] = email.split("@");
  const visibleChars = Math.min(3, Math.floor(localPart.length / 2));
  const maskedLocal =
    localPart.slice(0, visibleChars) + "*".repeat(localPart.length - visibleChars);
  return `${maskedLocal}@${domain}`;
}
